import { useState, useEffect, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { criarAlerta } from 'actions'
import { useExameCoincidenciaPerfisService } from 'hooks/useExameCoincidenciaPerfisService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import useRouter from 'utils/useRouter'

export const useInformacaoSINAB = () => {
  const params = useParams()
  const router = useRouter()
  const dispatch = useDispatch()
  
  const exameCoincidenciaPerfisService = useExameCoincidenciaPerfisService()
  const exameRealizadoService = useExameRealizadoService()
  
  const [processando, setProcessando] = useState(false)
  const [formState, setFormState] = useState({
    idExame: params.idExameRealizado,
    numLaudo: '',
    numLigacoes: '0',
  })

  const fetchInformacao = useCallback(async () => {
    if (params.idExameRealizado) {
      const response = await exameCoincidenciaPerfisService.listarExameCoincidenciaPerfisAsync(params.idExameRealizado)
      if (!response) {
        dispatch(
          criarAlerta(
            { status: 501 },
            router,
            `/casos/caso/solicitacao/exameSolicitado/detalhar/${params.idExameSolicitado}`
          )
        )
      }
    }
  }, [params.idExameRealizado, params.idExameSolicitado, dispatch, router])

  useEffect(() => {
    fetchInformacao()
  }, [fetchInformacao])

  useEffect(() => {
    const formSINAB = JSON.parse(localStorage.getItem('@sigep/formSINAB') || '{}')
    if (formSINAB && formSINAB.idExame === params.idExameRealizado) {
      setFormState({
        idExame: formSINAB.idExame || params.idExameRealizado,
        numLaudo: formSINAB.numLaudo || '',
        numLigacoes: formSINAB.numLigacoes || '0',
      })
    } else {
      localStorage.removeItem('@sigep/formSINAB')
    }
  }, [params.idExameRealizado])

  const isValid = useMemo(() => {
    if (formState.numLigacoes === '0') return true
    return !!(formState.numLaudo && formState.numLaudo.trim().length > 0)
  }, [formState.numLigacoes, formState.numLaudo])

  const handleChange = useCallback((e) => {
    const { name, value } = e.target
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }))
  }, [])

  const handleLaudoChange = useCallback((e) => {
    const input = e.target.value
    const regex = /^[a-zA-Z0-9\-]*$/
    if (regex.test(input) || input === '') {
      setFormState((prev) => ({
        ...prev,
        numLaudo: input.toUpperCase(),
      }))
    }
  }, [])

  const handleFinalizarExame = useCallback(async () => {
    const payload = {
      ...formState,
      numLaudo: formState.numLigacoes === '0' ? null : formState.numLaudo,
    }
    
    localStorage.setItem('@sigep/formSINAB', JSON.stringify(payload))
    await exameRealizadoService.gerarDocumento(params.idExameRealizado, setProcessando, payload)
    
    router.history.push({
      pathname: `/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${params.idExameRealizado}`,
      state: { IgnoneUploadImagem: true, tipoExame: 'INFO_TECNICA_SINAB' },
    })
  }, [formState, params.idExameRealizado, router])

  return {
    processando,
    formState,
    isValid,
    handleChange,
    handleLaudoChange,
    handleFinalizarExame,
    router,
  }
}
